<template>
  <v-footer :fixed="fixed" app>
    <span>JDGTechnology C.A. &copy; 2019</span>
  </v-footer>
</template>

<script>
export default {
  data () {
    return {
      fixed: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PageFooter.vue